import './ChangeNotes.scss';
// Font Awesome Icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//import { faBold, faItalic } from "@fortawesome/pro-solid-svg-icons";
import { faNote } from "@fortawesome/sharp-light-svg-icons";

interface ChangeNotesProps {
    text: string;
    setText: (value: string) => void;
}

export function ChangeNotes(props: ChangeNotesProps) {
    const { text, setText } = props,
          maxChars = 300;

    const handleInput = (element: HTMLTextAreaElement) => {
        if (element) {
            let textContent = element.value ?? text ?? "";

            // Remove excessive consecutive new lines (e.g., limit to 2 consecutive new lines)
            textContent = textContent.replace(/(\r?\n){3,}/g, '\n\n');
    
            // Check if the text content exceeds maxChars
            if (textContent.length > maxChars) {
                textContent = textContent.substring(0, maxChars);
            }

            setText(textContent);

            if (textContent !== element.value)
                element.value = textContent;
        }
    };

    return (
        <div>
            <div id='notesHeader'>
                <h2>
                    <FontAwesomeIcon id="uploadTemplateIcon" icon={faNote} />
                    &nbsp;
                    Change Notes
                </h2>
            </div>
            <div id='notesContainer'>
                <textarea id="changeNotesInput" 
                          aria-label="Change notes"
                          maxLength={maxChars}
                          onChange={(ev) => handleInput(ev.target)} />
            </div>
        </div>
    );
};
